require('./common.js');

require('./scores.js');

require('./events/datatable.js');

require('./events/menu.js');

require('./events/teams.js');
require('./events/round_teams.js');

require('./events/auto_configurations/shotgun.js');
require('./events/auto_configurations/tee_times.js');
require('./events/match_play.js');

require('./events/actions.js');

require('./rounds/form.js');
require('./rounds/handicaps.js');
require('./rounds/games.js');
require('./rounds/calculations.js');
require('./rounds/match_plays.js');

require('./players/index.js');
require('./players/search.js');
require('./players/tbd.js');
require('./players/toggleContactFields.js');

require('./series/pointsDatatable.js');
require('./series/reports/scoresSummary.js');

require('./tee_groups/index.js');

require('./cards/index.js');

require('../web_app/mobile_scoring.js');
